<h2 mat-dialog-title>Add File History</h2>
<div mat-dialog-content>
  <form class="doc-version-form">
    <div class="row">
      <mat-form-field>
        <mat-label>Doc Subtype</mat-label>
        <mat-select [formControl]="controls.controls.doc_subtype_id">
          @for (subType of docType.docSubtypes; track subType) {
            <mat-option
              [value]="subType.id"
              >{{ subType.name }}</mat-option
              >
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Status</mat-label>
          <mat-select [formControl]="controls.controls.doc_status_id">
            @for (status of statuses; track status) {
              <mat-option [value]="status.id">{{
                status.name
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field>
          <mat-label>Status Date</mat-label>
          <input
            matInput
            type="string"
            [matDatepicker]="picker"
            [formControl]="controls.controls.status_date" />
          <mat-datepicker-toggle
            matIconSuffix
          [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-hint>MM/DD/YYYY</mat-hint>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Version</mat-label>
          <input
            matInput
            type="number"
            [formControl]="controls.controls.version" />
        </mat-form-field>
      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="save()">Save</button>
    <button mat-raised-button (click)="this.dialogRef.close()">Cancel</button>
  </div>
